<template>
    <article>
        <fieldset class="form-group my-4">
            <legend>Filter before selecting village(s)</legend>

            <div class="alert alert-info">To select multiple option, Please hold <q>Ctrl</q> button while selecting.</div>

            <section class="row">

                <div class="col-sm-6 my-2">
                    <label>Province selecion (can select many)</label>
                    <select
                        class="form-control border border-dark"
                        size="8"
                        v-model.number="provinceArray"
                        multiple >

                        <option v-for="item in provinces" :value="item.id">
                            <span class="badge badge-secondary">{{ item.code }}</span>
                            {{ item.name }}
                        </option>

                    </select>
                </div>

                <div class="col-sm-6 my-2" v-show="provinceIsSelected">
                    <label>District selecion (can select many)</label>
                    <select
                        class="form-control border border-dark"
                        size="8"
                        v-model.number="districtArray"
                        multiple >

                        <option v-for="item in districts" :value="item.id">
                            <span class="badge badge-secondary">{{ item.code }}</span>
                            {{ item.name }}
                        </option>

                    </select>
                </div>

            </section>

            <section class="row">
                <div class="col-sm-6 my-2" v-show="districtIsSelected">
                    <label>Sector selecion (can select many)</label>
                    <select
                        class="form-control border border-dark"
                        size="8"
                        v-model.number="sectorArray"
                        multiple >

                        <option v-for="item in sectors" :value="item.id">
                            <span class="badge badge-secondary">{{ item.code }}</span>
                            {{ item.name }}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 my-2" v-show="sectorIsSelected">
                    <label>Cell selecion (can select many)</label>
                    <select
                        class="form-control border border-dark"
                        size="8"
                        v-model.number="cellArray"
                        multiple >

                        <option v-for="item in cells" :value="item.id">
                            <span class="badge badge-secondary">{{ item.code }}</span>
                            {{ item.name }}
                        </option>

                    </select>
                </div>

            </section>

            <div class="alert alert-info my-4">
                When you reach cell's level in filter above this message,
                villages can be selected in fields under this message.
                Too many villages (near 15 000) would be loaded without filter.
            </div>

        </fieldset>

        <section class="form-group">
            <label for="village_id">Village</label>
            <html-v-select
                name="village_id"
                label="codePlusName"
                item-value="id"
                :selected="locatedInside"
                :options="villages" >
            </html-v-select>
        </section>

        <section class="form-group">
            <label for="villages_served">Villages served:</label>
            <html-v-select-multiple
                name="villages_served[]"
                label="codePlusName"
                item-value="id"
                :selected="servesVillages"
                :options="villages" >
            </html-v-select-multiple>
        </section>

    </article>
</template>

<script>
export default {

    props: {

        provinces: {
            type: Array,
            required: true
        },

        locatedInside: {
            type: Object,
            default: {}
        },

        servesVillages: {
            type: Array,
            default: []
        }

    },

    data() {
        return {
            // id(s) containers
            provinceArray: [],
            districtArray: [],
            sectorArray: [],
            cellArray: [],
            // AJAX result containers
            districts: [],
            sectors: [],
            cells: [],
            villages: []
        };
    },

    computed: {

        provinceIsSelected() {
            return (this.provinceArray.length > 0);
        },

        districtIsSelected() {
            return (this.districtArray.length > 0);
        },

        sectorIsSelected() {
            return (this.sectorArray.length > 0);
        },

        cellIsSelected(){
            return (this.cellArray.length > 0);
        }

    },

    watch: {

        provinceArray(){
            if (!this.provinceIsSelected) return;

            this.cellArray = [];
            this.sectorArray = [];
            this.districtArray = [];

            this.commonAjax("provinceArray", "districts");
        },

        districtArray(){
            if (!this.districtIsSelected) return;

            this.cellArray = [];
            this.sectorArray = [];

            this.commonAjax("districtArray", "sectors");
        },

        sectorArray(){
            if (!this.sectorIsSelected) return;

            this.cellArray = [];

            this.commonAjax("sectorArray", "cells");
        },

        cellArray() {
            if (!this.cellIsSelected) return;

            this.commonAjax("cellArray", "villages");
        }

    },

    methods: {

        commonAjax(keyWordIndex, subDomainKeyWordIndex){
            window.axios.get( window.APP_URL + "/administrative-units/" + subDomainKeyWordIndex + "/filter/" + this[keyWordIndex])
                .then((response) => { this[subDomainKeyWordIndex] = response.data; })
                .catch((error) => { window.console.error(error); });
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/water-source/VillageFilter.vue